export default __webpack_public_path__ + "static/Temporary-Dumpster-Rental-f5f094a3123cbe5aa20fba2c476130a3.jpg";